import { render } from "./ModelExports.vue?vue&type=template&id=cae5e1b4"
import script from "./ModelExports.vue?vue&type=script&lang=js"
export * from "./ModelExports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__